import * as React from "react";

import Header from "./molecules/Header";
import HomeLink from "./molecules/HomeLink";

const NotFound = () => (
  <>
    <HomeLink />
    <Header>404 Not Found!</Header>
  </>
);

export default NotFound;
